import { RouterModule } from '@angular/router';
export var appRoutes = [];
export var appRoutingProviders = [];
export var routing = RouterModule.forRoot(appRoutes);
